
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M10.5 2.625a3.5 3.5 0 013.5 3.5 3.5 3.5 0 01-3.5 3.5 3.499 3.499 0 01-3.5-3.5c0-1.934 1.566-3.5 3.5-3.5zm3.5 9.223c0 .927-.245 3.088-1.916 5.503l-.709-4.226.822-1.645a15.1 15.1 0 00-1.697-.105 15.1 15.1 0 00-1.697.105l.822 1.645-.709 4.226C7.245 14.936 7 12.775 7 11.848c-2.091.612-3.5 1.714-3.5 3.027v3.5h14v-3.5c0-1.313-1.4-2.415-3.5-3.027z","fill-opacity":".7"}}),_c('path',{attrs:{"d":"M3.595.47L3.5.175 3.405.47l-.651 2.004H.339l.25.18 1.704 1.24-.651 2.003-.096.293.25-.181L3.5 4.769l1.705 1.239.249.18-.096-.292-.65-2.004 1.704-1.238.249-.181H4.246L3.596.469z","fill":"#DBA514","stroke":"#A07500","stroke-width":".2"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h21v21H0z"}})])])])
          )
        }
      }
    